// Element Plus support removed — kept empty plugin to avoid accidental imports
import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin(() => {
  // no-op
});
